import React, { useState, useEffect } from "react";
import { Input } from "antd";
import { formatNumber, removeThousandSeparator } from "../../../services";
import styles from "./RangeInput.scss";
const thousands = formatNumber(1000).slice(1, 2);

const RangeInput = props => {
  const { placeholder, value: propValue, onChange, numberFormatted } = props;
  const [value, setValue] = useState("");

  useEffect(() => {
    if (propValue) {
      if (!Number(propValue)) {
        setValue(propValue);
      } else {
        let processedValue = propValue.toString();
        if (numberFormatted) {
          processedValue = removeThousandSeparator(processedValue, thousands);
        }
        const textValue = numberFormatted
          ? formatNumber(parseInt(processedValue, 10))
          : processedValue.toString();
        setValue(textValue);
      }
    } else {
      setValue("");
    }
  }, [propValue, numberFormatted]);

  useEffect(() => {
    if (propValue == null && value != null) {
      setValue(null);
    }
  }, [propValue, value]);

  const handleChange = e => {
    const eventValue = e.target.value;
    let newValue = eventValue;
    // Remove thousands separator before parse the number, the eventValue could be : 1,1111
    if (numberFormatted) {
      newValue = removeThousandSeparator(newValue, thousands);
    }
    newValue = parseInt(newValue, 10);

    const textValue = Number.isNaN(newValue)
      ? eventValue.substring(0, eventValue.length - 1)
      : formatNumber(newValue);
    e.target.value = Number.isNaN(newValue) ? null : newValue;

    setValue(textValue);
    onChange(e);
  };

  return (
    <span className={`range-control ${styles.input}`}>
      <Input
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        // @ts-ignore
        inputMode={"numeric"}
      />
    </span>
  );
};

RangeInput.defaultProps = {
  onChange: () => null
};

export default RangeInput;



// WEBPACK FOOTER //
// ./src/components/FormControls/RangeControl/RangeInput.tsx